interface BlogPostingSchemaProps {
  headline: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
  imageUrl?: string;
  keywords?: string[];
}

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

export const blogPostingJsonLd = (props: BlogPostingSchemaProps) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  '@id': `${props.url}/#article`,
  headline: props.headline,
  description: props.description,
  url: props.url,
  datePublished: props.datePublished,
  dateModified: props.dateModified,
  author: {
    '@type': 'Person',
    name: props.authorName,
  },
  publisher: {
    '@type': 'Organization',
    '@id': `${siteUrl}/#business`,
    name: 'Pop Pro Tents',
    logo: {
      '@type': 'ImageObject',
      url: `${siteUrl}/vite.svg`,
    },
  },
  ...(props.imageUrl ? {
    image: {
      '@type': 'ImageObject',
      url: props.imageUrl,
    },
  } : {}),
  ...(props.keywords?.length ? {
    keywords: props.keywords.join(', '),
  } : {}),
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': props.url,
  },
  inLanguage: 'en-US',
  isPartOf: {
    '@type': 'Blog',
    '@id': `${siteUrl}/blog/#blog`,
  },
});